import React, {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {eyebrow} from './WaLink';
import {faqItems, gallery} from '../data/salon';

const items = [
  {q: 'My makeup felt like me, just more polished. Lovely, calm experience.', who: 'Demo client · Party makeup'},
  {q: 'Warm welcome and unhurried care. I left feeling relaxed and radiant.', who: 'Demo client · Facial'},
  {q: 'Thoughtful, gentle and professional from start to finish.', who: 'Demo client · Hair styling'},
];

function Testimonials() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-20 sm:px-6">
      <div className="mb-10 text-center">
        <span className={eyebrow}>Customer testimonials</span>
        <h2 className="font-display mt-3 text-4xl text-[#0B3B36] sm:text-5xl">Kind words <em className="text-[#C8553D]">(demo).</em></h2>
        <p className="mt-2 text-xs text-[#4b5d59]">Sample content for this demo, not verified reviews.</p>
      </div>
      <div className="grid gap-5 md:grid-cols-3">
        {items.map((t, i) => (
          <article key={t.who} className="rounded-2xl bg-[#E4EDE6] p-7">
            <div className="flex items-center gap-3">
              <img src={gallery[i + 2]} alt="" className="h-14 w-14 rounded-full object-cover" />
              <div className="text-[#E9A23B]" aria-label="Five stars">★★★★★</div>
            </div>
            <blockquote className="font-display mt-5 text-lg leading-relaxed text-[#0B3B36]">“{t.q}”</blockquote>
            <p className="mt-5 text-xs font-semibold text-[#C8553D]">{t.who}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-[#F3E6CF] py-20">
      <div className="mx-auto grid max-w-[1280px] gap-10 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr]">
        <div>
          <span className={eyebrow}>FAQ</span>
          <h2 className="font-display mt-3 text-4xl text-[#0B3B36] sm:text-5xl">Good to <em className="text-[#C8553D]">know.</em></h2>
        </div>
        <div className="space-y-3">
          {faqItems.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.question} className="rounded-xl bg-[#FBF5EA]">
                <button type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-display text-lg text-[#0B3B36]">
                  {f.question}
                  <SafeIcon icon={isOpen ? FiIcons.FiMinus : FiIcons.FiPlus} className="shrink-0 text-[#C8553D]" />
                </button>
                {isOpen && <p className="px-6 pb-5 text-sm leading-relaxed text-[#4b5d59]">{f.answer}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export {Testimonials, FAQ};
